/* eslint-disable */
import * as Types from '../../../../clients/graphqlTypes.js';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UseTemplateAvailableVersionQueryVariables = Types.Exact<{
  templateId: Types.Scalars['ID']['input'];
}>;


export type UseTemplateAvailableVersionQuery = { quoteTemplates: { __typename: 'MissingCapabilities' } | { __typename: 'MissingPermissions' } | { __typename: 'QuoteTemplateConnection', edges: Array<{ __typename: 'QuoteTemplateEdge', node: { __typename: 'QuoteTemplate', id: string, resolvedAsReadModelVersionNumber?: number | null, latestAvailableVersionNumber?: number | null, latestPublishedVersionNumber?: number | null } }> } };


export const UseTemplateAvailableVersionDocument = gql`
    query UseTemplateAvailableVersion($templateId: ID!) {
  quoteTemplates(
    limit: 1
    filters: {templateIds: [$templateId], sources: [available]}
  ) {
    ... on QuoteTemplateConnection {
      edges {
        node {
          id
          resolvedAsReadModelVersionNumber
          latestAvailableVersionNumber
          latestPublishedVersionNumber
        }
      }
    }
  }
}
    `;

/**
 * __useUseTemplateAvailableVersionQuery__
 *
 * To run a query within a React component, call `useUseTemplateAvailableVersionQuery` and pass it any options that fit your needs.
 * When your component renders, `useUseTemplateAvailableVersionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUseTemplateAvailableVersionQuery({
 *   variables: {
 *      templateId: // value for 'templateId'
 *   },
 * });
 */
export function useUseTemplateAvailableVersionQuery(baseOptions: Apollo.QueryHookOptions<UseTemplateAvailableVersionQuery, UseTemplateAvailableVersionQueryVariables> & ({ variables: UseTemplateAvailableVersionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UseTemplateAvailableVersionQuery, UseTemplateAvailableVersionQueryVariables>(UseTemplateAvailableVersionDocument, options);
      }
export function useUseTemplateAvailableVersionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UseTemplateAvailableVersionQuery, UseTemplateAvailableVersionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UseTemplateAvailableVersionQuery, UseTemplateAvailableVersionQueryVariables>(UseTemplateAvailableVersionDocument, options);
        }
export function useUseTemplateAvailableVersionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UseTemplateAvailableVersionQuery, UseTemplateAvailableVersionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UseTemplateAvailableVersionQuery, UseTemplateAvailableVersionQueryVariables>(UseTemplateAvailableVersionDocument, options);
        }
export type UseTemplateAvailableVersionQueryHookResult = ReturnType<typeof useUseTemplateAvailableVersionQuery>;
export type UseTemplateAvailableVersionLazyQueryHookResult = ReturnType<typeof useUseTemplateAvailableVersionLazyQuery>;
export type UseTemplateAvailableVersionSuspenseQueryHookResult = ReturnType<typeof useUseTemplateAvailableVersionSuspenseQuery>;
export type UseTemplateAvailableVersionQueryResult = Apollo.QueryResult<UseTemplateAvailableVersionQuery, UseTemplateAvailableVersionQueryVariables>;